import styles from "@/components/layout/Navbar/Bookmarks/Bookmarks.module.css";
import { CloseIcon } from "@/components/ui/Icons";
import { MenuListItemIcon, MenuListLinkItem } from "@/components/ui/MenuList";
import { IconButton } from "@/components/ui/buttons/IconButton";
import { BookmarkItem } from "@/features/bookmarks/bookmarks.types";
import { useBookmarksActions } from "@/features/bookmarks/useBookmarksActions";

type Props = {
    item: BookmarkItem;
    onClick: () => void;
};

const iconMap: Record<BookmarkItem["type"], string> = {
    customer: "lely-icon-human",
    device: "lely-icon-robot", // TODO: Support Astronaut icon
    farm: "lely-icon-farm",
    technician: "lely-icon-person",
};

const BookmarksListItem = (props: Props) => {
    const { item } = props;
    const { removeBookmarkAction } = useBookmarksActions();

    const icon = iconMap[item.type];

    return (
        <MenuListLinkItem to={item.url} className={styles.bookmarks_list_item} onClick={props.onClick}>
            <MenuListItemIcon icon={icon} />
            {item.title}

            <IconButton
                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    e.stopPropagation();
                    e.preventDefault();
                    removeBookmarkAction(item.type, item.id);
                }}
                variant="text"
                size="sm"
                className={styles.bookmarks_list_item_remove_button}
            >
                <CloseIcon />
            </IconButton>
        </MenuListLinkItem>
    );
};

export { BookmarksListItem as BookmarkListItem };
